import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconQuestionCircleSvg } from "./IconQuestionCircleSvg.mjs";
const IconQuestionCircle = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconQuestionCircleSvg, ...iconProps });
};
export {
  IconQuestionCircle
};
